import React, { useState } from "react";
import { ArrowLeft, Mail } from "lucide-react";
import { Button } from "../ui";

interface ForgotPasswordFormProps {
  onSubmit: (email: string) => Promise<void>;
  isLoading?: boolean;
  onBackToLogin: () => void;
}

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({
  onSubmit,
  isLoading = false,
  onBackToLogin,
}) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email) {
      setError("Email là bắt buộc");
      return;
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      setError("Email không hợp lệ");
      return;
    }

    setError(null);
    await onSubmit(email);
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label
            htmlFor="email"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Email
          </label>
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={`block w-full pl-10 pr-4 py-2 border rounded-md focus:ring-1 focus:ring-[#0087C1] focus:border-[#0087C1] text-sm ${
                error ? "border-red-300" : "border-gray-300"
              }`}
              placeholder="example@email.com"
            />
          </div>
          {error && <p className="mt-1 text-xs text-red-600">{error}</p>}
        </div>

        <Button
          type="submit"
          isLoading={isLoading}
          loadingText="Đang gửi email..."
          variant="primary"
          size="md"
        >
          Gửi email đặt lại mật khẩu
        </Button>
      </form>

      {/* Back to Login Button - Bottom */}
      <div className="mt-6 text-center">
        <Button
          onClick={onBackToLogin}
          variant="ghost"
          size="sm"
          className="flex items-center justify-center text-[#0087C1]"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Quay lại đăng nhập
        </Button>
      </div>
    </div>
  );
};

export default ForgotPasswordForm;
